const state = {
    userInfo: '',
    balance: '',
    pending: '',
    todayRate: ''
};

export default state;